// TODO: Import React module
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// TODO: Import MUI module
import {
    Alert, Autocomplete, Box, Button, Grid,
    Link, Paper, Snackbar, Stack, TextField, Typography
} from '@mui/material';

// TODO: Import MUI icon
import { ZoomIn } from '@mui/icons-material';

// TODO: Import context
import { Context, fetchData, Webservices } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../../Common/BoxSubPage';
import { ContentTitle } from '../../Common/TypographyTYH';

// TODO: Export component
const imageBaseUrl = 'https://www.pohtyh.edu.hk/Files/CafeOrder';

const CafeOrderDisplay = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component CafeOrderDisplay Rendered');

    // TODO: Define useContext

    // TODO: Define variable
    const [rows, setRows] = useState([]);

    // TODO: Define event
    useEffect(() => { window.scrollTo(0, 0); }, []);

    const getOrder = useCallback(() => {
        const formData = new FormData();
        formData.append('action', 'CafeOrderDisplay_GetData');
        fetchData(formData, (result) => {
            setRows(result);
        });
    }, []);

    useEffect(() => {
        getOrder();

        const id = setInterval(() => {
            getOrder();
        }, 10000);

        return () => clearInterval(id);
    }, [getOrder]);

    // TODO: Return component
    return (
        <BoxSubPage
            id="CafeOrderDisplay"
            disableTop={true}
            disableMenu={true}
            disableSubtitle={true}
            disableDivider={true}
            disableFooter={true}
        >
            <Stack spacing={2} sx={{ mb: 4 }}>
                <Stack sx={{ mb: 4 }}>
                    <Typography sx={{ fontWeight: 'bold' }} variant="h2">
                        {`以下訂單編號可到前台領取`}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold' }} variant="h4">
                        {`The following order numbers can be collected at the front desk`}
                    </Typography>
                </Stack>
                <Grid container>
                    {rows.map(item => (
                        <Grid size={{ xs: 3 }} key={item.ID}>
                            <Typography sx={{ fontWeight: 'bold' }} variant="h1">{String(item.ID).padStart(3, '0')}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </Stack>
        </BoxSubPage>
    );
};

export default CafeOrderDisplay;